/** Calendar-day geometry without DST-length days or UTC parsing of date fields. */
const DAY_MS = 86400000;

export function calendarDay(value) {
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split('-').map(Number);
    return Date.UTC(y, m - 1, d) / DAY_MS;
  }
  const date = value instanceof Date ? value : new Date(value);
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / DAY_MS;
}

export function dateAtDay(day) {
  const utc = new Date(Math.floor(day) * DAY_MS);
  return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate());
}

export function dateStringAtDay(day) {
  return new Date(Math.floor(day) * DAY_MS).toISOString().slice(0, 10);
}
